<script>
    export let icon = 'far fa-check'
    export let label = null
    export let busy = false
    export let disabled = false
    export let visited = false
    export let danger = false
    export let success = false
</script>

<style>
    .ActionButton {
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        text-align: center;
        border: none;
        padding: 0;
        margin: 0;
        background-color: #fff;
        color: #4a727f;
        outline: none;
    }
    .ActionButton.withLabel {
        width: auto;
        padding: 0 10px;
    }
    .ActionButton.visited {
        background-color: var(--forge-action-primary-bg);
        color: #fff;
    }
    .ActionButton:hover {
        background-color: #4a727f;
        color: #fff;
    }
    .ActionButton.danger {
        background-color: #ff6b6b;
        color: #fff;
    }
    .ActionButton.danger:hover {
        background-color: #d65050;
    }
    .ActionButton.success {
        background-color: #2dbef9;
        color: #fff;
    }
    .ActionButton.success:hover {
        background-color: #0a5d9c;
    }
    .ActionButton.disabled {
        background-color: var(--text-secondary);
        color: #fff;
    }
    .ActionButton:active {
        background-color: var(--components-primary-bg);
        color: #fff;
    }
</style>

<button 
    {disabled}
    class="ActionButton" 
    class:withLabel={label !== null} 
    class:danger class:success class:busy class:disabled class:visited on:click|stopPropagation>
    {#if busy}
        <i class="icn far fa-sync fa-spin"></i>
    {:else if label}
        {label}
    {:else}
        <i class="icn {icon}"></i>
    {/if}
</button>